import React, { useEffect, useRef } from "react";

/**
 * Pointer-reactive 3D tilt wrapper. Tilts children toward the cursor on
 * fine-pointer (desktop) devices only, and is disabled under
 * prefers-reduced-motion. Mutates the ref's transform directly (no re-render).
 */
export const TiltCard = ({ children, max = 8, className = "" }) => {
  const ref = useRef(null);
  const raf = useRef(0);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof window === "undefined" || !window.matchMedia) return;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    const fine = window.matchMedia("(pointer: fine)");
    if (reduce.matches || !fine.matches) return;

    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        el.style.transform = `perspective(1200px) rotateY(${px * max}deg) rotateX(${-py * max}deg)`;
      });
    };
    const onLeave = () => {
      cancelAnimationFrame(raf.current);
      el.style.transform = "perspective(1200px) rotateY(0deg) rotateX(0deg)";
    };

    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);
    return () => {
      el.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
      cancelAnimationFrame(raf.current);
    };
  }, [max]);

  return (
    <div ref={ref} className={`phone-tilt-3d ${className}`.trim()}>
      {children}
    </div>
  );
};
